"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerGameProfile = PlayerGameProfile;
const React = __importStar(require("react"));
const models_1 = require("@creature-chess/models");
const ui_1 = require("@creature-chess/ui");
const BalanceIcon_1 = require("~/components/ui/icon/BalanceIcon");
const CoinIcon_1 = require("~/components/ui/icon/CoinIcon");
const LevelIcon_1 = require("~/components/ui/icon/LevelIcon");
const sessionContext_1 = require("~/game/sessionContext");
const networking_1 = require("~/networking");
const plugins_1 = require("~/plugins");
const players_1 = require("~/store/game/players");
const useStyles_1 = require("~/useStyles");
const progressBar_1 = require("../../ui/progressBar");
const useStyles = (0, useStyles_1.createUseThemeStyles)(() => ({
    profile: {
        "display": "flex",
        "flexDirection": "row",
        "alignItems": "center",
        "color": "#fff",
        "background": "#566c86",
        "margin": "8px",
        "padding": "8px 12px",
        "gap": "12px",
        "@media (orientation: portrait) and (max-width: 400px)": {
            margin: "6px",
            padding: "6px 10px",
            gap: "10px",
        },
    },
    xpColumn: {
        display: "flex",
        flexDirection: "column",
        flex: "1",
        minWidth: 0,
        gap: "4px",
    },
    xpHeader: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        fontSize: "0.8rem",
    },
    xpCount: {
        color: "#cdd7e3",
    },
    xpProgress: {
        height: "10px",
        background: "#38465e",
        borderRadius: "3px",
        overflow: "hidden",
    },
    xpProgressFill: {
        background: "#ddc160",
    },
    maxLevel: {
        flex: "1",
        textAlign: "center",
        fontWeight: 700,
    },
}));
function PlayerGameProfile() {
    const styles = useStyles();
    const { buyXpAmount, buyXpCost } = (0, sessionContext_1.useGamemodeSettings)();
    const gameActions = (0, networking_1.useGameActions)();
    const localPlayer = (0, players_1.useLocalPlayer)();
    if (!localPlayer) {
        return null;
    }
    const { level, xp, money } = localPlayer;
    const isMaxLevel = level === models_1.MAX_LEVEL;
    const canAfford = money >= buyXpCost;
    return (React.createElement(plugins_1.Region, { cls: "player-profile-bar", ctx: { level, xp, money } },
        React.createElement("div", { className: styles.profile },
            React.createElement(BalanceIcon_1.BalanceIcon, { amount: money }),
            isMaxLevel ? (React.createElement("div", { className: styles.maxLevel },
                React.createElement(LevelIcon_1.LevelIcon, { amount: level }),
                " Max level!")) : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: styles.xpColumn },
                    React.createElement("div", { className: styles.xpHeader },
                        React.createElement(LevelIcon_1.LevelIcon, { amount: level }),
                        React.createElement("span", { className: styles.xpCount },
                            xp,
                            "/",
                            (0, models_1.getXpToNextLevel)(level),
                            " XP")),
                    React.createElement(progressBar_1.ProgressBar, { className: styles.xpProgress, fillClassName: styles.xpProgressFill, current: xp, max: (0, models_1.getXpToNextLevel)(level) })),
                React.createElement(ui_1.Button, { onClick: gameActions.buyXp, disabled: !canAfford, color: "secondary", size: "small" },
                    "Buy ",
                    buyXpAmount,
                    " XP (",
                    buyXpCost,
                    " ",
                    React.createElement(CoinIcon_1.CoinIcon, null),
                    ")"))))));
}
